
import axiosInstance from "./AxiosInstanceMain";

export const getMyLeadsApi = async (params = {}) => { const response = await axiosInstance.get("/leads/my-leads", { params }); return response.data; };

export const getNewLeadsApi = async (params = {}) => { const response = await axiosInstance.get("/leads/new-leads", { params }); return response.data; };

export const getLeadsByUserIdApi = async (userId, query = "") => {
  const response = await axiosInstance.get(`/leads/user/${userId}${query ? `?${query}` : ""}`);
  return response.data;
};

export const createLeadViewHistoryApi = async (source, leadId) => {
  return axiosInstance.post(`/leads/view/${source}/${leadId}`);
};

export const getLeadDetailsApi = (source, leadId) =>
  axiosInstance.get(`/leads/details/${source}/${leadId}`);

export const updateLeadStageApi = (source, leadId, data) =>
  axiosInstance.patch(`/leads/stage/${source}/${leadId}`, data);

export const updateLeadRemarkApi = (source, leadId, data) =>
  axiosInstance.patch(`/leads/remark/${source}/${leadId}`, data);

export const getLeadActivityApi = (source, leadId, params = {}) =>
  axiosInstance.get(`/leads/activity/${source}/${leadId}`, { params });

export const createLeadActivityLogApi = (source, leadId, data) =>
  axiosInstance.post(`/leads/activity-log/${source}/${leadId}`, data);

export const syncLeadsNowApi=async()=>{
  const response=await axiosInstance.post("/lead-sync/sync-now");
  return response;
};